import { date,  showAlert } from '../../../lib/helpers';
import {
  dataSourceOnboardingList,
  dataListMerchantCriteria,
  dataListAccountStatus,
  dataAllQrType,
  dataSettlementTypeItems,
} from '../../../store/params';
import { headers, search } from './attributes';


export default {
  data: () => ({
    listButton: {
      buttonRestart: true,
      buttonDots: true,
      buttonDotsExt: [
        {
          link: 'exportItemParent',
          show: true,
          icon: 'mdi-file-excel',
          title: 'Export to excel',
          voidStatus: true,
        },
      ],
    },
    options: {},
    headers,
    editedIndex: -1,
    search,
    filterValue: { source_onboarding: '', merchant_name: '', mid: '', nmid: '', mpan: '', address: '', merchant_criteria: '', qr_type: '', settlement_type:'', created_at: [], deactivated_at: [], status: '' },
    filterConfig: [
      { key: 'source_onboarding', type: 'select', props: { label: 'Source Onboarding', items: dataSourceOnboardingList } },
      { key: 'merchant_name', type: 'textfield', props: { label: 'Nama Merchant' } },
      { key: 'mid', type: 'textfield', props: { label: 'MID' } },
      { key: 'nmid', type: 'textfield', props: { label: 'NMID' } },
      { key: 'mpan', type: 'textfield', props: { label: 'MPAN' } },
      { key: 'address', type: 'textfield', props: { label: 'Alamat Lengkap' } },
      { key: 'merchant_criteria', type: 'select', props: { label: 'Kriteria Merchant', items: dataListMerchantCriteria } },
      { key: 'qr_type', type: 'select', props: { label: 'Jenis QR', items: dataAllQrType } },
      { key: 'settlement_type', type: 'select', props: { label: 'Settlement Type', items: dataSettlementTypeItems } },
      { key: 'created_at', type: 'daterange', props: { label: 'Tanggal Active', includeToday: true } },
      { key: 'deactivated_at', type: 'daterange', props: { label: 'Tanggal Inactive', includeToday: true } },
      { key: 'status', type: 'select', props: { label: 'Status', items: dataListAccountStatus } },
    ]
  }),

  computed: {
    idAggregator() {
      return this.$route.params.idAggregator;
    },
    isOutletAggregator() {
      return this.$route.name !== 'ListOutletMerchant';
    },
    isStateAggregator() {
      return this.isOutletAggregator ? 'aggregator' : 'merchant';
    },
    flashErrorMessage() {
      return this.$store.state.client[this.isStateAggregator].flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.client[this.isStateAggregator].flashError;
      },
      set() {
        this.$store.commit(
          `client/${this.isStateAggregator}/setFlashErrorMessage`,
          ''
        );
      },
    },

    loading() {
      return this.$store.state.client[this.isStateAggregator].loading;
    },
    allData() {
      return this.$store.state.client[this.isStateAggregator].allMerchants;
    },
    totalPage() {
      return this.$store.state.client[this.isStateAggregator].totalPage;
    },
    totalData() {
      return this.$store.state.client[this.isStateAggregator].totalMerchants;
    },
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  async mounted() {
    this.$store.commit(`client/${this.isStateAggregator}/clearMerchants`);
  },

  methods: {
    baseFilterData(newSearch) {
      this.search.source_onboarding = newSearch.source_onboarding || '';
      this.search.merchant_name = newSearch.merchant_name || '';
      this.search.mid = newSearch.mid || '';
      this.search.nmid = newSearch.nmid || '';
      this.search.mpan = newSearch.mpan || '';
      this.search.address = newSearch.address || '';
      this.search.merchant_criteria = newSearch.merchant_criteria || '';
      this.search.qr_type = newSearch.qr_type || '';
      this.search.settlement_type = newSearch.settlement_type || '';
      this.search.created_at = newSearch.created_at || [];
      this.search.deactivated_at = newSearch.deactivated_at || [];
      this.search.status = newSearch.status || '';
      this.options.page = 1;
      this.getData(); 
    },
    updateSearch(newSearch) {
      this.baseFilterData(newSearch);
    },
    showType(newSearch) {
      this.baseFilterData(newSearch);
    },
    clearSearch() {
      this.search.source_onboarding = '';
      this.search.merchant_name = '';
      this.search.nmid = '';
      this.search.mpan = '';
      this.search.mobile_phone = '';
      this.search.mid = '';
      this.search.merchant_criteria = '';
      this.search.qr_type = '';
      this.search.address = '';
      this.search.settlement_type = '';
      this.search.status = '';
      this.search.created_at = [];
      this.search.deactivated_at = [];
      this.$nextTick(() => {
        this.getData();
      });
    },

    getData() {
      this.$store.commit(
        `client/${this.isStateAggregator}/setFlashErrorMessage`,
        ''
      );
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch(`client/${this.isStateAggregator}/fetchMerchants`, {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
          aggregatorId: this.idAggregator,
          merchantId: this.$route.params.id,
          action: 'outlet',
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    viewItem(item) {
      this.$router.push({ path: `/client/merchant/view/${item.id}` });
    },

    exportItem() {
      if (this.totalData === 0) {
        this.$vuetify.goTo(0);
        showAlert(
          this.$store,
          'Data is empty !',
          'mdi-alert',
          'red'
        );
        return;
      }
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store.dispatch(`client/${this.isStateAggregator}/exportList`, {
        date,
        page,
        itemsPerPage,
        sortBy,
        sortDesc,
        search: this.search,
        view: this.isOutletAggregator
          ? 'sub-merchant-outlet'
          : 'merchant-outlet',
        IDAggregator: '',
        IDMerchant: this.$route.params.id,
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    this.clearSearch();
    next();
  },
};